/* TOT seit 2026-07-09: Searchanise entfernt, Include aus theme.liquid ausgebaut — Ersatz: predictive-search.js (native FTK-Treffer). Datei nur noch als Referenz. */
/**
 * FTK Farbton-Integration for Searchanise Predictive Search
 *
 * Searchanise replaces Shopify's native predictive search entirely.
 * This script injects FTK color swatches into the Searchanise results dropdown.
 *
 * Detection: Input-event-based polling + MutationObserver backup.
 */
(function () {
  'use strict';

  var FTK_API = 'https://sto-projektberater-v3.farbenbote.workers.dev/api/ftk/search';
  var SNIZE_CONTAINER = '#snize-instant-search-results';
  var MIN_QUERY_LENGTH = 2;
  var MAX_RESULTS = 6;
  var DEBOUNCE_MS = 250;
  var POLL_INTERVAL = 150;
  var POLL_MAX_RETRIES = 15;
  var DEBUG = true;

  var lastQuery = '';
  var debounceTimer = null;
  var currentController = null;
  var ftkCache = {};
  var pollTimer = null;

  function log() {
    if (!DEBUG) return;
    var args = ['[FTK Search]'].concat(Array.prototype.slice.call(arguments));
    console.log.apply(console, args);
  }

  /* ---- Visibility Helpers ---- */

  function isVisible(el) {
    if (!el) return false;
    var rect = el.getBoundingClientRect();
    if (rect.height === 0 && rect.width === 0) return false;
    var style = window.getComputedStyle(el);
    return style.display !== 'none' && style.visibility !== 'hidden';
  }

  function ensureVisible(el) {
    if (!el) return;
    var style = window.getComputedStyle(el);
    if (style.display === 'none') {
      el.style.setProperty('display', 'block', 'important');
      log('Force-showed hidden element:', el.className || el.id);
    }
    if (style.visibility === 'hidden') {
      el.style.setProperty('visibility', 'visible', 'important');
    }
  }

  /* ---- Find the active search input ---- */

  function getSearchInput() {
    // Try multiple selectors — Searchanise may use its own input
    var selectors = [
      'input[name="q"]:focus',
      '.snize-input-style',
      'input.snize-search-input',
      'input[name="q"]'
    ];
    for (var i = 0; i < selectors.length; i++) {
      var el = document.querySelector(selectors[i]);
      if (el && el.value && el.value.trim().length > 0) return el;
    }
    return null;
  }

  function getQuery() {
    var input = getSearchInput();
    return input ? input.value.trim() : '';
  }

  /* ---- Initialisation ---- */

  function init() {
    log('Initializing...');

    // Primary: Listen for input events on search fields
    document.addEventListener('input', onSearchInput, true);

    // Backup: MutationObserver for Searchanise DOM changes
    var observer = new MutationObserver(onMutation);
    observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['style', 'class']
    });

    log('Ready. Listening for search input.');
  }

  /* ---- Input Handler ---- */

  function onSearchInput(e) {
    var el = e.target;
    if (!el || el.tagName !== 'INPUT') return;
    // Accept any search-like input (name=q, or Searchanise inputs)
    if (el.name !== 'q' && !el.classList.contains('snize-input-style') && !el.classList.contains('snize-search-input')) return;

    var query = el.value.trim();
    if (query === lastQuery) return;

    log('Input changed:', query);

    // Remove old FTK results if query changed
    removeFtkResults();
    lastQuery = query;

    clearTimeout(debounceTimer);
    clearTimeout(pollTimer);

    if (!query || query.length < MIN_QUERY_LENGTH) return;

    debounceTimer = setTimeout(function () {
      // Start FTK fetch
      doFetch(query).then(function (data) {
        if (data) {
          ftkCache[query] = data;
          log('FTK data cached for:', query, '(' + data.results.length + ' results)');
        }
        // Start polling for Searchanise container
        pollForContainer(query, 0);
      });
    }, DEBOUNCE_MS);
  }

  /* ---- MutationObserver Handler (backup) ---- */

  function onMutation() {
    var container = document.querySelector(SNIZE_CONTAINER);
    if (!container) return;
    // Accept container even if hidden — we may need to force-show it for FTK
    if (!isVisible(container) && !container.querySelector('.snize-ac-results-columns')) return;

    var target = getInjectionTarget(container);
    if (target.querySelector('.ftk-search-results')) return;

    var query = getQuery();
    if (!query || query.length < MIN_QUERY_LENGTH) return;

    if (ftkCache[query]) {
      log('MutationObserver: injecting cached FTK for', query);
      injectFtk(container, ftkCache[query], query);
    }
  }

  /* ---- Poll for Searchanise Container ---- */

  function pollForContainer(query, attempt) {
    if (attempt >= POLL_MAX_RETRIES) {
      log('Polling stopped after', attempt, 'attempts for:', query);
      return;
    }

    // Check if query has changed since we started polling
    var currentQuery = getQuery();
    if (currentQuery !== query) {
      log('Query changed during polling, aborting for:', query);
      return;
    }

    var container = document.querySelector(SNIZE_CONTAINER);

    // Container must exist; it may be hidden if Searchanise found no products
    if (container && (isVisible(container) || container.querySelector('.snize-ac-results-columns'))) {
      var target = getInjectionTarget(container);
      if (target.querySelector('.ftk-search-results')) {
        log('FTK already injected, skipping');
        return;
      }

      var data = ftkCache[query];
      if (data && data.results && data.results.length > 0) {
        log('Poll hit! Container found, injecting FTK (attempt', attempt + ')');
        injectFtk(container, data, query);
        return;
      } else {
        log('Container found but no FTK data yet, retrying...');
      }
    }

    // Retry
    pollTimer = setTimeout(function () {
      pollForContainer(query, attempt + 1);
    }, POLL_INTERVAL);
  }

  /* ---- Fetch ---- */

  function doFetch(query) {
    if (ftkCache[query]) return Promise.resolve(ftkCache[query]);

    // Abort previous request
    if (currentController) {
      try { currentController.abort(); } catch (e) { /* ignore */ }
    }
    currentController = new AbortController();

    log('Fetching FTK for:', query);

    return fetch(
      FTK_API + '?q=' + encodeURIComponent(query) + '&limit=' + MAX_RESULTS,
      { signal: currentController.signal }
    )
      .then(function (res) {
        if (!res.ok) { log('FTK API error:', res.status); return null; }
        return res.json();
      })
      .catch(function (err) {
        if (err.name !== 'AbortError') log('FTK fetch error:', err);
        return null;
      });
  }

  /* ---- Inject + Remove ---- */

  function removeFtkResults() {
    var existing = document.querySelectorAll('.ftk-search-results');
    for (var i = 0; i < existing.length; i++) {
      existing[i].remove();
    }
    // Clean up ftk-only-results class
    var marked = document.querySelectorAll('.ftk-only-results');
    for (var j = 0; j < marked.length; j++) {
      marked[j].classList.remove('ftk-only-results');
    }
  }

  function getInjectionTarget(container) {
    // Target: first (left) column inside Searchanise results
    var leftCol = container.querySelector('.snize-ac-results-columns .snize-ac-results-column');
    return leftCol || container;
  }

  function isOnFarbtonfinder() {
    return window.location.pathname.indexOf('farbtonfinder') !== -1;
  }

  function closeSearchanise() {
    // Close the Searchanise dropdown
    var container = document.querySelector(SNIZE_CONTAINER);
    if (container) container.style.display = 'none';
    // Blur the search input to fully dismiss
    var input = getSearchInput();
    if (input) input.blur();
  }

  function hideFarbkartenSection(target) {
    // Remove Searchanise "Farbkarten" section from left column
    var headings = target.querySelectorAll('.snize-ac-results-title');
    for (var i = 0; i < headings.length; i++) {
      var text = headings[i].textContent.trim().toUpperCase();
      if (text === 'FARBKARTEN' || text.indexOf('FARBKARTE') !== -1) {
        // Hide the heading and its sibling list
        var wrapper = headings[i].closest('.snize-ac-results-items') || headings[i].parentElement;
        if (wrapper) {
          wrapper.style.display = 'none';
          log('Hidden Farbkarten section');
        }
      }
    }
  }

  function injectFtk(container, data, query) {
    if (!data || !data.results || !data.results.length) return;

    var target = getInjectionTarget(container);
    if (target.querySelector('.ftk-search-results')) return;

    // Hide Farbkarten section
    hideFarbkartenSection(target);

    var section = document.createElement('div');
    section.className = 'ftk-search-results';
    section.innerHTML = buildHtml(data, query);

    // On farbtonfinder page: intercept clicks to trigger hash navigation
    if (isOnFarbtonfinder()) {
      section.addEventListener('click', function (e) {
        var link = e.target.closest('.ftk-color-item');
        if (!link) return;
        e.preventDefault();
        var href = link.getAttribute('href');
        var hashPart = href.split('#')[1];
        if (hashPart) {
          window.location.hash = hashPart;
          closeSearchanise();
          // Trigger FTK restoreFromUrlHash if available
          if (window.FTK && typeof window.FTK.restoreFromUrlHash === 'function') {
            window.FTK.restoreFromUrlHash();
          } else {
            // Dispatch hashchange event as fallback
            window.dispatchEvent(new HashChangeEvent('hashchange'));
          }
        }
      });
    }

    target.prepend(section);

    // Force-show column structure if Searchanise hid it (no product results)
    ensureVisible(target);
    var columns = container.querySelector('.snize-ac-results-columns');
    if (columns) ensureVisible(columns);
    var content = container.querySelector('.snize-ac-results-content');
    if (content) ensureVisible(content);
    ensureVisible(container);

    // Hide Searchanise "no results" message since we have FTK results
    var noResults = container.querySelector('.snize-no-results-message, .snize-ac-results-no-results');
    if (noResults) {
      noResults.style.display = 'none';
      log('Hidden Searchanise no-results message');
    }

    // Mark container so CSS can adapt layout (FTK-only, no products)
    var hasProducts = container.querySelector('.snize-product, .snize-ac-results-products .snize-item');
    if (!hasProducts) {
      container.classList.add('ftk-only-results');
      log('No Searchanise products found, added ftk-only-results class');
    }

    log('Injected', data.results.length, 'FTK colors into', target === container ? 'container (fallback)' : 'left column');
  }

  /* ---- Build HTML ---- */

  function buildHtml(data, query) {
    var items = data.results.slice(0, MAX_RESULTS).map(function (r) {
      var hex = r.h || '#888';
      var name = escapeHtml(r.n || r.i);
      var cardSlug = r.c || '';
      var cardLabel = escapeHtml(
        cardSlug.split('-').map(function (w) {
          return w.charAt(0).toUpperCase() + w.slice(1);
        }).join(' ')
      );
      var url = '/pages/farbtonfinder?card=' + encodeURIComponent(cardSlug) + '&ton=' + encodeURIComponent(r.i);

      return '<a href="' + url + '" class="ftk-color-item">' +
        '<span class="ftk-swatch" style="background-color:' + hex + '"></span>' +
        '<span class="ftk-color-info">' +
          '<span class="ftk-name">' + name + '</span>' +
          '<span class="ftk-card">' + cardLabel + '</span>' +
        '</span>' +
      '</a>';
    }).join('');

    var total = data.total || data.results.length;
    var seeAllUrl = '/pages/farbtonfinder' + (query ? '?q=' + encodeURIComponent(query) : '');

    return '<div class="ftk-section-header">FARBT\u00D6NE</div>' +
      '<div class="ftk-color-list">' + items + '</div>' +
      (total > MAX_RESULTS
        ? '<a href="' + seeAllUrl + '" class="ftk-see-all">Alle ' + total + ' Farbt\u00F6ne anzeigen \u2192</a>'
        : '');
  }

  function escapeHtml(str) {
    var div = document.createElement('div');
    div.textContent = str;
    return div.innerHTML;
  }

  /* ---- Start ---- */

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
